import fm from "front-matter";

// Manually maintain this list of slugs.
// It should match the filenames in /public/news/ without the .md extension.
const newsSlugs = [
  "kuria-bar",
  "korosi-tulangan-baja",
  "tips-rumah-ramah-lingkungan",
  "fiberglass-dalam-konstruksi",
  "GFRP-rebar-inovasi-juara",
  "budidaya-udang-modern",
  "optimasi-area-parkir",
  "uji-lab-kuria-bar",
  "GFRP-rebar-di-luar-negeri",
  "epoxy-pada-GFRP-rebar",
  "cara-jadi-distributor-kuria",
  "warna-kuria-bar",
  "kuria-bar-hemat-ongkir",
  "GFRP-atau-FRP",
  "proyek-luas-hemat",
  "infrastruktur-tahan-rob",
  "frp-green-building",
  "mrt-jakarta-pakai-material-komposit-ffu",
  "gudang-cepat-jadi-budget-irit",
  "bangun-lapangan-padel",
];

/**
 * Fetches and parses the frontmatter for all news articles.
 * @returns {Promise<Array<Object>>} A promise that resolves to an array of metadata objects, sorted by date descending.
 */
export const getNewsMetadata = async () => {
  try {
    const metadataPromises = newsSlugs.map(async (slug) => {
      const response = await fetch(`/news/${slug}.md`);
      if (!response.ok) {
        throw new Error(
          `Failed to fetch /news/${slug}.md: ${response.statusText}`
        );
      }
      const markdown = await response.text();
      // Use front-matter to parse only the frontmatter
      const { attributes } = fm(markdown);
      return { ...attributes, slug }; // Ensure slug is part of the metadata
    });

    const metadata = await Promise.all(metadataPromises);

    // Sort by date, newest first
    metadata.sort((a, b) => new Date(b.date) - new Date(a.date));

    return metadata;
  } catch (error) {
    console.error("Error fetching news metadata:", error);
    return []; // Return empty array on error
  }
};

/**
 * Fetches and parses a single news article (frontmatter and content).
 * @param {string} slug - The slug of the news article to fetch.
 * @returns {Promise<{data: Object, content: string}|null>} A promise that resolves to the parsed article or null if not found/error.
 */
export const getNewsArticle = async (slug) => {
  try {
    const response = await fetch(`/news/${slug}.md`);
    if (!response.ok) {
      console.error(`Article not found for slug: ${slug}`);
      return null; // Handle 404 or other errors gracefully
    }
    const markdown = await response.text();
    const { attributes, body } = fm(markdown);
    return { data: attributes, content: body };
  } catch (error) {
    console.error(`Error fetching article ${slug}:`, error);
    return null; // Return null on error
  }
};
